export default {
  quote: {
    url: '/sig/quote'
  },
  logos: {
    url: 'sig/logos'
  }
}



// WEBPACK FOOTER //
// ./src/common/services/service-directory.js